import React from 'react';

import Request from './Request';
import Reset from './Reset';

import type { UserType } from '@/types/domain/user/redux';

/**
 * プロパティ
 */
export type Props = {
  /** 送信するか */
  isSubmit: boolean,
  /** ユーザー */
  user?: UserType,
};

const ForgotPassword: React.FC<Props> = ({ isSubmit, user }) => {
  if (isSubmit) {
    if (user) {
      return <Reset username={user.name} />;
    }
    return null;
  }
  return <Request />;
};

export default ForgotPassword;
